<template>
  <v-layout row justify-center>
    <v-dialog v-model="updateDialog" persistent max-width="600px">
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>{{title}}</v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12>
                <v-text-field label="ID du modèle" v-model="modeleInput" required></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
          <small>{{message}}</small>
        </v-card-text>
        <v-divider/>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click="toggleDialog" :disabled="updating">Annuler</v-btn>
          <v-btn
            color="blue darken-1"
            flat
            @click.prevent="updateAsync(modeleInput);"
            :disabled="updating"
          >Mettre à jour</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
export default {
  props: [
    "updateDialog",
    "updateAsync",
    "toggleDialog",
    "updating",
    "modeleId",
    "title",
    "message"
  ],
  data: () => ({
    modeleInput: ""
  }),
  watch: {
    updateDialog: function(newVal) {
      if (newVal) {
        this.modeleInput = this.modeleId;
      }
    }
  }
};
</script>

